<section class="login  bg-primary common-img-bg">
    <div class="d-flex justify-content-center justify-content-md-end w-100">
        <div class="mx-5" style="min-width: 450px;">
            <form 
                class="md-float-material" 
                (ngSubmit)="submitResetpass($event)" #formResetpass="ngForm"
                novalidate>
                <div class="text-center">
                    <img src="../assets/images/logo_login.png" alt="logo.png">
                </div>
                <div class="auth-box p-4">
                    <h3 class="text-center txt-primary mt-1">Restablecer Contraseña</h3>
                    <hr />
                    <div class="input-group">
                        <input 
                            type="text" 
                            class="form-control" 
                            (paste)="prevenirPegado($event)"
                            placeholder='Usuario' 
                            name="Login"
                            [(ngModel)]="resetpassForm.Login">
                        <span class="md-line"></span>
                    </div>
                    <div class="grid">
                        <div class="row m-t-30">
                            <div class="col-md-6">
                                <button 
                                    type="submit"
                                    class="btn btn-primary btn-md btn-block waves-effect text-center m-b-20"
                                    (click)="cancelar()"
                                >
                                    Regresar
                                </button>
                            </div>
                            <div class="col-md-6">
                                <button 
                                    type="submit"
                                    class="btn btn-primary btn-md btn-block waves-effect text-center m-b-20"
                                >
                                    Restablecer
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <footer class="footer py-2 grid footerLogin">
        <div class="row">
            <div class="col-12 col-md-2">Versión {{version}}</div>
            <div class="col-12 col-md-2">Soporte técnico</div>
            <div class="col-12 col-md-5 d-inline-flex align-items-center justify-content-center">
                <svg style="margin-right: 8px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                    fill="currentColor" class="bi bi-envelope me-2" viewBox="0 0 16 16">
                    <path
                        d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741zM1 11.105l4.708-2.897L1 5.383z" />
                </svg>
                soporteycalidad@spot-itpro.com
            </div>
            <div class="col-12 col-md-3 d-inline-flex align-items-center justify-content-center">
                <svg style="margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" width="17" height="17"
                    fill="currentColor" class="bi bi-phone me-2" viewBox="0 0 16 16">
                    <path
                        d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                    <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                </svg>
                +52(55)5336 4391
            </div>
        </div>
    </footer>
</section>

